import { useEffect, useMemo, useState } from 'react'

export const useReportRefreshKey = ({ wasCreated, wasUpdated, wasDeleted, selectedYear }) => {
  // Counter that increments when a report is created, updated, or deleted to force select refresh (never decrements)
  const [refreshCounter, setRefreshCounter] = useState(0)

  // Increment counter when a report is created to trigger select refresh
  useEffect(() => {
    if (wasCreated) {
      setRefreshCounter(prev => prev + 1)
    }
  }, [wasCreated])

  // Increment counter when a report is updated to trigger select refresh
  useEffect(() => {
    if (wasUpdated) {
      setRefreshCounter(prev => prev + 1)
    }
  }, [wasUpdated])

  // Increment counter when a report is deleted to trigger select refresh
  useEffect(() => {
    if (wasDeleted) {
      setRefreshCounter(prev => prev + 1)
    }
  }, [wasDeleted])

  // Create a reset key that changes when year changes or counter increments
  const resetKey = useMemo(() => {
    return `${selectedYear}-${refreshCounter}`
  }, [selectedYear, refreshCounter])

  return resetKey
}
